// src/cert/iso14001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO14001 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 14001 प्रमाणन</h1>
                <p>पर्यावरण व्यवस्थापन प्रणाली (Environmental Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>..ISO 14001..</h2>
                    <p>
                        ISO 14001 sets the Standard for environmental management systems.

                        If you want to reduce waste management costs and demonstrate your commitment to protecting the environment, you need ISO 14001 certification. Implementing this global Environmental Management Standard will also help your organisation comply with increasingly stringent environmental laws and regulations and build trust with customers and other stakeholders. Helping you to reduce your environmental impact, save money and win more business.

                        So far, we helped to put over 30,000 management systems in place for businesses like yours. As one of the UKs leading ISO certification bodies, we can help you to develop compliant policies for your organisation and achieve ISO 14001 certification in as little as 45 days.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>पर्यावरणीय कायद्यांचे अनुपालन</li>
                        <li>ऊर्जा, पाणी, कच्चा मालाचा खर्च कमी</li>
                        <li>कचरा आणि प्रदूषण कमी</li>
                        <li>संस्थेची पर्यावरणीय प्रतिष्ठा वाढते</li>
                        <li>ग्राहक, सरकार, गुंतवणूकदारांचा विश्वास वाढतो</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 14001 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 14001" />
                </section>
            </div>
        </div>
    );
};

export default ISO14001;